// CustomerSupport.ts
import { IAPIErrorResult, getObject, getOfficeMdBaseUri, postObject, postObjectWithApiError, putObject } from "../ChoiceApi";

export function byteArrayUrl(sizeInBytes:number): string{
    return `${getOfficeMdBaseUri()}api/CustomerSupport/ByteArray/${sizeInBytes}`;
}

// Return an error if there is an issue, undefined if fine
export async function saveEnvironmentCheckResult(results: EnvironmentCheckDataModel): Promise<IAPIErrorResult|undefined>
{
    const result = await postObjectWithApiError("api/CustomerSupport/EnvironmentCheck/Data", results);
    return result.error;
}

export function environmentCheckResultUrl()
{
    return "/officemd/App/CustomerSupport/EnvironmentCheck";
}

export async function getEnvironmentCheckResults(days: number = 30, userId?: string) : Promise<SavedEnvironmentCheckDataModel[] | undefined>
{
    return await getObject(`api/CustomerSupport/EnvironmentCheck/Data/${days}/${userId ?? ""}`);
}

export async function getEnvironmentCheckGlobalMetrics(days: number = 30) : Promise<EnvironmentCheckMetricsModel | undefined>
{
    return await getObject(`api/CustomerSupport/EnvironmentCheck/Metrics/${days}`);
}
export async function getEnvironmentCheckCompanyMetrics(days: number = 30) : Promise<EnvironmentCheckMetricsModel | undefined>
{
    return await getObject(`api/CustomerSupport/EnvironmentCheck/Metrics/Company/${days}`);
}
export async function GetDate() : Promise<Date | undefined>
{
    return await getObject('api/CustomerSupport/EnvironmentCheck/Date');
}
export async function logPageError(errorInfo: PageErrorModel): Promise<void>
{
    await postObject(
        "api/CustomerSupport/PageError", 
        errorInfo,
        {
            errorCallback: (_httpResp, _errorMessage) => {
                // Fail silently -- is telemetry data so don't want to complain to the end user
                console.log("Error trying to log page error");
            }
        }
    );
}

export async function getLoggedPageErrors(days: number = 30, userId?: string): Promise<UserPageError[] | undefined>
{
    if (userId)
        return await getObject(`api/CustomerSupport/PageErrors/${days}/${userId}`);
    return await getObject(`api/CustomerSupport/PageErrors/${days}`);
}

export async function getPageErrorDetails(id: string): Promise<UserPageErrorDetails | undefined>
{
    return await getObject(`api/CustomerSupport/PageErrors/Details/${id}`);
}

export async function generateSupportPin(): Promise<number | undefined>
{
    return await putObject(`api/CustomerSupport/SupportPin`);
}

export async function validateSupportPin(supportPin: number): Promise<SupportPinValidationResult | undefined>
{
    return await getObject(`api/CustomerSupport/SupportPin/${supportPin}`);
}


export interface EnvironmentCheckDataModel
{
    results: EnvironmentCheckResultsModel,
    settings: EnvironmentCheckSettingsModel
}

export interface EnvironmentCheckResultsModel
{
    fibonacciTestTime?: number,
    domTestTime?: number,
    downloadThirdPartyTime?: number,
    downloadOurServerTime?: number,
    downloadThirdPartyFailureCount?: number,
    downloadOurServerFailureCount?: number
}

export interface EnvironmentCheckSettingsModel
{
    fibonacciTestLoopCount: number,
    thirdPartyDownloadUrl: string,
    downloadResourceByteCount: number,
    downloadResourceReps: number
}

export interface SavedEnvironmentCheckDataModel
{
    fibonacciTestTime?: number,
    domTestTime?: number,
    downloadThirdPartyTime?: number,
    downloadOurServerTime?: number,
    timestamp?: Date
}

export interface EnvironmentCheckPercentiles
{
    median?: number,
    top75Percent?: number,
    top90Percent?: number,
    top95Percent?: number
}

export interface EnvironmentCheckMetricsModel
{
    fibonacciTestTime?: EnvironmentCheckPercentiles,
    domTestTime?: EnvironmentCheckPercentiles,
    downloadThirdPartyTime?: EnvironmentCheckPercentiles,
    downloadOurServerTime?: EnvironmentCheckPercentiles,
    countOfResults?: number,
    days?: number
};

export interface PageErrorModel
{
    message?: string, 
    source?: string, 
    lineno?: number,
    colno?: number,
    details?: string,
    contentType?: string
}

export interface UserPageError
{
    docId?: string,
    message?: string,
    source?: string,
    line?: number,
    column?: number,
    timestamp?: Date, 
    hasDetails?: boolean,
    contentType?: string
}

export interface UserPageErrorDetails
{
    contentType?: string,
    details?: string
}

export interface SupportPinValidationResult
{
    success: boolean,
    data?: string,
    message?: string
}